import React from 'react';

const DialogHeaderTitle = ({ children }) => (
  <div className="ws-ui-dialog-header-title">{children}</div>
);

export default DialogHeaderTitle;
